(() => {
  const KEY = "nlz_age_verified_tab";
  const VERIFIED_VALUE = "yes";

  // --- CONTROLLO DI ESCLUSIONE SPECIFICO ---
  // Verifica se siamo nella pagina "business-card"
  // Shopify aggiunge la classe "template-page-[handle]" al body.
  // Per /pages/business-card, la classe è "template-page-business-card".
  const isExcludedPage = document.body.classList.contains('template-page-business-card');
  
  // In alternativa, controllo diretto sull'URL se la classe non funzionasse:
  const isExcludedUrl = window.location.pathname === '/pages/business-card';

  // Se siamo nella pagina esclusa, interrompi lo script immediatamente
  if (isExcludedPage || isExcludedUrl) {
    return; 
  }
  // -----------------------------------------

  // Se già verificato in QUESTA tab, non mostrare
  try {
    if (sessionStorage.getItem(KEY) === VERIFIED_VALUE) return;
  } catch (e) {}

  const isDesignMode = window.Shopify && Shopify.designMode;

  const overlay = document.createElement("div");
  overlay.id = "nlz-age-gate";
  overlay.innerHTML = `
    <div class="nlz-age-gate__card" role="dialog" aria-modal="true" aria-labelledby="nlz-age-title">
      <h2 id="nlz-age-title">Accesso riservato ai maggiorenni</h2>
      <p>Confermando dichiari di avere almeno 18 anni.</p>
      <div class="nlz-age-gate__actions">
        <button type="button" class="nlz-age-gate__btn nlz-age-gate__btn--yes">Ho 18+</button>
        <button type="button" class="nlz-age-gate__btn nlz-age-gate__btn--no">Non ho 18</button>
        ${isDesignMode ? `<button type="button" class="nlz-age-gate__btn nlz-age-gate__btn--close">Chiudi (anteprima)</button>` : ``}
      </div>
    </div>
  `;

  document.body.appendChild(overlay);

  const yesBtn = overlay.querySelector(".nlz-age-gate__btn--yes");
  const noBtn = overlay.querySelector(".nlz-age-gate__btn--no");
  const closeBtn = overlay.querySelector(".nlz-age-gate__btn--close");

  function closeGate() {
    overlay.remove();
  }

  yesBtn.addEventListener("click", () => {
    try { sessionStorage.setItem(KEY, VERIFIED_VALUE); } catch (e) {}
    closeGate();
  });

  noBtn.addEventListener("click", () => {
    window.location.href = "/pages/accesso-riservato";
  });

  if (closeBtn) closeBtn.addEventListener("click", closeGate);
})();
